import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { updateApiLogsSelectedFilters } from '../../../../../../data/redux/apilogs_details/actions'
import { debounced } from '../../../../../../data/config/utils'

import CustomHeader from '../../../../../../components/customheader'

const status_codes = [
  { name: "200", value: 200 },
  { name: "204", value: 204 },
  { name: "400", value: 400 },
  { name: "401", value: 401 },
  { name: "404", value: 404 },
  { name: "403", value: 403 },
  { name: "408", value: 408 },
  { name: "500", value: 500 },
  { name: "503", value: 503 },
  { name: "504", value: 504 },
]

const ApiLogsHeader = ({
  actions,
  selected_filters
}) => {

  const { updateApiLogsSelectedFilters } = actions

  const handleChangeSwitch = isSuccess => updateApiLogsSelectedFilters({ isSuccess })

  const debounceSearch = debounced(sessionId => {
    updateApiLogsSelectedFilters({ sessionId: sessionId.trim() })
  }, 500)

  const handleSearchChange = event => {
    const sessionId = event.target.value
    debounceSearch(sessionId)
  }

  const handleDateRangeChange = date_range => {
    updateApiLogsSelectedFilters({ startDate: date_range[0], endDate: date_range[1] })
  }

  const handleStatusCodeChange = statusCode => actions.updateApiLogsSelectedFilters({ statusCode })

  return (
    <CustomHeader
      container_class="ori-lr-pad-10"
      title="API Logs"
      search_placeholder="Search By Session ID"
      switch_class={selected_filters.isSuccess ? "ori-bg-green" : "ori-bg-danger"}
      switch_text={selected_filters.isSuccess ? "Success" : "Failed"}
      switch_checked={selected_filters.isSuccess}
      dropdown_value={selected_filters.statusCode ? selected_filters.statusCode : "Status Code"}
      dropdown_match_select_width
      dropdown_options={status_codes}
      date_range={[selected_filters.startDate, selected_filters.endDate]}
      onChangeSwitch={handleChangeSwitch}
      onChangeSearch={handleSearchChange}
      onChangeDateRange={handleDateRangeChange}
      onChangeDropdown={handleStatusCodeChange}
      bottom_bordered
      show_switch
      show_dropdown
      show_search
      show_date_range
    />
  )
}

const mapStateToProps = state => {
  return {
    selected_filters: state.apilogs_details.selected_filters,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateApiLogsSelectedFilters
      },
      dispatch
    )
  }
}

ApiLogsHeader.propTypes = {
  actions: PropTypes.object,
  selected_filters: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiLogsHeader)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/console/apilogs/ApiLogsHeader/index.js